(function () {
  const instances = new Map();

  function getPartnersRoot(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('vecharge-partners')) return root;
    return root.querySelector('.vecharge-partners');
  }

  function destroySwiper(sectionId) {
    const instance = instances.get(sectionId);
    if (instance) {
      instance.destroy(true, true);
      instances.delete(sectionId);
    }
  }

  function initPartnersSection(root) {
    const section = getPartnersRoot(root);
    const swiperEl = section && section.querySelector('[data-partners-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const sectionId = section.id;
    destroySwiper(sectionId);

    const prevButton = section.querySelector('[data-partners-prev]');
    const nextButton = section.querySelector('[data-partners-next]');
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    if (slideCount === 0) return;

    const slidesDesktop = Number(swiperEl.dataset.slidesDesktop || 6);
    const slidesTablet = Number(swiperEl.dataset.slidesTablet || 4);
    const slidesMobile = Number(swiperEl.dataset.slidesMobile || 2);
    const spaceBetween = Number(swiperEl.dataset.spaceBetween || 32);
    const autoplay = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = Number(swiperEl.dataset.autoplayDelay || 4000);

    const swiper = new Swiper(swiperEl, {
      slidesPerView: slidesMobile,
      spaceBetween: spaceBetween,
      loop: slideCount > slidesDesktop,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },
      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceBetween
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween
        }
      }
    });

    instances.set(sectionId, swiper);
  }

  function initAllPartnersSections(root) {
    root.querySelectorAll('.vecharge-partners').forEach(function (section) {
      initPartnersSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllPartnersSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPartnersSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = getPartnersRoot(event.target);
    if (section) destroySwiper(section.id);
  });
})();
